export { default } from "./LogisticTask-component";
